import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  progress: {
    minWidth: '10rem',
  },
});
